import { type Ref, onBeforeUnmount, onMounted, ref, watch } from 'vue';

export function useIsOverflowing(
  elRef: Ref<HTMLElement | null>,
  watchSource?: () => unknown,
) {
  const isOverflowing = ref(false);

  function measure() {
    const el = elRef.value;
    if (!el) return;
    isOverflowing.value = el.scrollWidth > el.clientWidth;
  }

  let observer: ResizeObserver | null = null;

  onMounted(() => {
    observer = new ResizeObserver(measure);
    if (elRef.value) observer.observe(elRef.value);
    measure();
  });

  watch(elRef, (el, previous) => {
    if (previous) observer?.unobserve(previous);
    if (el) observer?.observe(el);
    measure();
  });

  onBeforeUnmount(() => observer?.disconnect());

  if (watchSource) watch(watchSource, measure, { flush: 'post' });

  return { isOverflowing, measure };
}
